import { render, staticRenderFns } from "./Autoflak.vue?vue&type=template&id=77a58b69&"
import script from "./Autoflak.vue?vue&type=script&lang=js&"
export * from "./Autoflak.vue?vue&type=script&lang=js&"
import style0 from "./Autoflak.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports